export const estimateTextWidth = (text: string): number => {
  return text.length * 7;
};
